import React, { useEffect, useCallback } from "react";
import useGlobalContext from "../../../hooks/useGlobalContext.js";
import useTrackerContext from "../../../hooks/useTrackerContext.js";
import useRouteName from "../../../hooks/useRouteName.js";
import useClientMetrics, { initClientMetrics } from "../../../hooks/useClientMetrics.js";
import useEvents from "../../../hooks/useEvents.js";
import { initializePerformanceObserver } from "../../../utils/client-performance-metrics.js";
import NoSSR from "../../../app/NoSSR/index.js";
const debug = require("debug")("trackers");
const Trackers = () => {
    const { payerId } = useGlobalContext();
    const { trackExternal } = useTrackerContext();
    const { trackClientMetric } = useClientMetrics();
    const currentRoute = useRouteName();
    const { jsError } = useEvents();
    const page = currentRoute || "unknown_page";
    const sendClassicMetricsToClientMetrics = useCallback((props) => {
        const { name, value } = props;
        debug(name, value);
        trackClientMetric(name, value);
    }, [trackClientMetric]);
    useEffect(() => {
        initializePerformanceObserver(sendClassicMetricsToClientMetrics);
    }, []);
    useEffect(() => {
        debug("Tracking Pageview: " + page);
        trackClientMetric("pageview");
    }, [page, trackClientMetric]);
    useEffect(() => {
        debug("Running Riskified page tracking...", page);
        switch (page) {
            case "checkout-pax":
            case "checkout-extras":
            case "checkout-payment":
                if (payerId) {
                    trackExternal({ type: "RISKX", action: "go", args: [page], data: { sessionId: payerId } });
                }
                else {
                    jsError(new Error("Trackers: missing payerId"));
                }
                break;
        }
    }, [page, payerId, trackExternal, jsError]);
    useEffect(initClientMetrics, []);
    return null;
};
const ClientOnlyTrackers = () => (React.createElement(NoSSR, null,
    React.createElement(Trackers, null)));
export default React.memo(ClientOnlyTrackers);
